import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';

/*
 * Fonts are bundled, not fetched from a CDN.
 *
 * The branding model rejects remote font URLs outright: a tenant running inside a
 * government or defence network has no route to fonts.googleapis.com, and a
 * stylesheet that blocks on one would leave the interface unstyled. Vite fingerprints
 * these and emits them alongside the rest of the assets.
 *
 * Only the weights the type scale actually uses are imported — each additional weight
 * is a separate woff2 on the critical path.
 */
import '@fontsource/space-grotesk/400.css';
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';

import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import '@/styles/index.css';

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root is missing from index.html.');

createRoot(container).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
);
